// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
/* Store Custom Code - Start */
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
        // Store Custom Code
        list: {
            contentSpacing: pxToRem(16),
        },
    },
    category: {
        image: {
            small: getImageSize(768, 514), // Store Custom Code
        },
    },
    // Store Custom Code
    menu: {
        mainNavigation: {
            underlineSize: pxToRem(2),
        },
    },
    typography: {
        fontFamily: {
            title: `Oswald, sans-serif`,
            base: `Poppins, sans-serif`,
        },
        lineHeight: {
            smaller: 1,
            smalll: 1.125,
            small: 1.25,
            semi: 1.375,
            base: 1.5,
            large: 1.75,
            larger: 2,
        },
    },
    header: {
        height: pxToRemArray([60, null, 90, 100, 110]),
        padding: pxToRemArray([10, null, 15]),
    },
};

export default design;
